export const defaultRules = [
  {
    name: "general",
    order: 1,
    value: "No",
    message: "Show a preliminary message?",
  },
  {
    name: "general",
    order: 2,
    value: "Proceed to schedule an appointment with CLIENTNAME",
    message: "Preliminary message text:",
  },
  {
    name: "general",
    order: 4,
    value: "No",
    message: "Scheduling SMS Confirmation",
  },
  {
    name: "general",
    order: 5,
    value:
      "Thank you for scheduling an appointment with {CLIENT_NAME}! You are all set for {APPT_DAY}, {APPT_MONTH} {APPT_DATE} {APPT_YEAR}. Please arrive at your appointment 10 minutes early. Feel free to call us at {LOCATION_PHONE} if you have any questions. If you need to change your appointment, please give us 24 hours notice. We look forward to seeing you!",
    message: "Scheduling SMS Confirmation template",
  },
  {
    name: "general",
    order: 6,
    value: "No",
    message: "48 Hrs Reminder SMS",
  },
  {
    name: "general",
    order: 7,
    value:
      "Thank you for scheduling an appointment with {CLIENT_NAME}! You are all set for {APPT_DAY}, {APPT_MONTH} {APPT_DATE} {APPT_YEAR}. Please arrive at your appointment 10 minutes early. Feel free to call us at {LOCATION_PHONE} if you have any questions. If you need to change your appointment, please give us 24 hours notice. We look forward to seeing you!",
    message: "48 Hrs Reminder SMS template",
  },
  {
    name: "general",
    order: 8,
    value: "No",
    message: "Same Day Reminder SMS",
  },
  {
    name: "general",
    order: 9,
    value:
      "This is a reminder that you have an appointment with {CLIENT_NAME} for {APPT_DATE}. Please arrive at your appointment 10 minutes early. Feel free to call us at {BUSINESS_PHONE} if you have any questions. We look forward to seeing you!",
    message: "Same Day Reminder SMS template",
  },
  {
    name: "landingPage",
    order: 1,
    value:
      "The selected service is not available for online scheduling. Please call our office to schedule your appointment",
    message: "Message for call-to-schedule services",
  },
  {
    name: "landingPage",
    order: 2,
    value: "No",
    message: "Allow patients to schedule multiple appointments?",
  },
  {
    name: "landingPage",
    order: 3,
    value:
      "It looks like you already have an appointment scheduled for APPTDATE at APPTTIME. If you need to make a change to that appointment, please call our office.",
    message: "Message for patients who already have an appointment",
  },
  {
    name: "appointment",
    order: 1,
    value: 10,
    message: "How far out can online appointments be scheduled for?",
  },
  {
    name: "appointment",
    order: 2,
    value: "BusinessDays",
    message: "Days Type",
  },
  {
    name: "appointment",
    order: 3,
    value: "No",
    message: "Allow provider changes for existing patients?",
  },
  {
    name: "appointment",
    order: 4,
    value: "alphabetic",
    message: "How to sort providers",
  },
  {
    name: "appointment",
    order: 5,
    value: "No",
    message: "Show providers with no capacity",
  },
  {
    name: "appointment",
    order: 6,
    value:
      "This provider has no online availability. Please call our office to schedule with them.",
    message: "Message for no-capacity providers",
  },
  {
    name: "appointment",
    order: 7,
    value: "No",
    message: "Offer waitlist for no-capacity providers",
  },
  {
    name: "appointment",
    order: 8,
    value:
      "This provider cannot be booked online. Please call our office to schedule with them.",
    message: "Message for provider that can't be booked online",
  },
  {
    name: "appointment",
    order: 9,
    value:
      "This location has no online availability. Please call our office to schedule.",
    message: "Message for no-capacity locations",
  },
  {
    name: "appointment",
    order: 10,
    value: "No",
    message: "Offer waitlist for no-capacity locations",
  },
  {
    name: "appointment",
    order: 11,
    value:
      "This service cannot be booked online. Please call our office to schedule.",
    message: "Message for service that can’t be booked online",
  },
  {
    name: "appointment",
    order: 12,
    value:
      "The selected location is not available for online scheduling. Please call our office to schedule your appointment.",
    message: "Message for online-off locations",
  },
  {
    name: "appointment",
    order: 13,
    value: "Yes",
    message: "Allow existing patients to schedule?",
  },
  {
    name: "appointment",
    order: 14,
    value:
      "Existing patients are not able to schedule online at this time. Please call our office to schedule your appointment.",
    message: "Message for existing patients",
  },
  {
    name: "appointment",
    order: 15,
    value: 2,
    message: "How soon can online appointments be scheduled for?",
  },
  {
    name: "appointment",
    order: 16,
    value: "BusinessDays",
    message: "Start days Type?",
  },
  {
    name: "appointment",
    order: 17,
    value: "No",
    message: "Group appointment slots by provider?",
  },
  {
    name: "appointment",
    order: 18,
    value: "random",
    message: "How to assign appointment when multiple providers are available",
  },
  {
    name: "appointment",
    order: 19,
    value:
      "The appointment slot you have selected is no longer available. Please call our office PHONENUMBER or click the button below to select a new appointment time",
    message: "Message for unavailable slots: ",
  },
  {
    name: "appointment",
    order: 20,
    value: "#024E94",
    message: "Widget Color",
  },
  {
    name: "appointment",
    order: 21,
    value: "No",
    message: "Show Providers",
  },
  {
    name: "appointment",
    order: 22,
    value:
      "This provider is inactive. Please call our office to schedule.",
    message: "Message for provider is inactive",
  },
  {
    name: "appointment",
    order: 23,
    value: "Yes",
    message: "Show prior appointment for existing patients?",
  },
  {
    name: "appointment",
    order: 24,
    value: "Yes",
    message: "Show upcoming appointment for existing patients?",
  },
  {
    name: "insurance",
    order: 1,
    value: "No",
    message: "Check insurance compatibility before booking",
  },
  {
    name: "insurance",
    order: 2,
    value:
      "Selected insurance plan is not in-network with the provider. Please call our office to book your appointment.",
    message: "Message for insurance plan not accepted by provider",
  },
  {
    name: "insurance",
    order: 3,
    value: "No",
    message: "Prevent self-pay patients from booking: (if insurance is 'No')",
  },
  {
    name: "insurance",
    order: 4,
    value:
      "We are not accepting self-pay patients at this time. We apologize for the inconvenience.",
    message: "Message for self-pay patients prevented from booking:",
  },
  {
    name: "insurance",
    order: 6,
    value: "error",
    message: "Message display type for self-pay patients:",
  },
  {
    name: "insurance",
    order: 7,
    value: "",
    message: "Insurance Page Text:",
  },
  {
    name: "insurance",
    order: 8,
    value: "Yes",
    message: "Show Insurance Type field?",
  },
{
    name: "insurance",
    order: 5,
    value: "manualForm",
    message: "Type of insurance intake form:",
  },
  {
    name: "thankYouScreen",
    order: 1,
    value:
      "Your appointment has been scheduled! If you need to reschedule, please contact us at least 48 hours in advance.",
    message: "Primary thank you message",
  },
  {
    name: "thankYouScreen",
    order: 2,
    value: "Call our office if you have any questions.",
    message: "Secondary thank you message",
  },
  {
    name: "thankYouScreen",
    order: 3,
    value: "Yes",
    message: "Automatically confirm appointments booked with this scheduler?",
  },
  {
    name: "patientIntake",
    order: 1,
    value: "required",
    message: "SMS & email permissions",
  },
];
